var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-detail-response"},[(_vm.dataRes.type === 'image')?_c('div',{staticClass:"image-response-wrapper"},[_c('ImageResponseDetails',{attrs:{"response":{
        formattedValue: _vm.dataRes.value,
        question: _vm.dataRes.question
      },"survey":{ questions: [_vm.dataRes.question]}}})],1):_c('div',{staticClass:"content-dynamic-detail-response",domProps:{"innerHTML":_vm._s(_vm.formatDetailResponse())}})])
}
var staticRenderFns = []

export { render, staticRenderFns }